// extracted by mini-css-extract-plugin
module.exports = {"loading":"_2Nypp4ybrbg-sxMGCIaZOg"};